import { useState } from 'react';
import ttsResource from 'flow/api/texttospeechv2';
import { convertBase64ToAudioBlob } from 'flow/utils/audio-utils';
import wrappedLocalStorage from 'flow/utils/local-storage-utils';

const mimeType = 'audio/mpeg';

interface AudioResult {
    url: string;
    duration: number;
    name: string;
}

export const useTTSGeneration = (setFile: (file: File | null) => void) => {
    const [loading, setLoading] = useState(false);
    const [audioResult, setAudioResult] = useState<AudioResult | null>(null);
    const [showConfirm, setShowConfirm] = useState(false);

    const checkConfirm = (onGenerate: () => void) => {
        if (wrappedLocalStorage.getItem('tts-generated') === 'true') {
            onGenerate();
        } else {
            setShowConfirm(true);
        }
    };

    const generateTTS = async (
        text: string,
        languageCode: string,
        voice: string,
    ) => {
        setLoading(true);
        ttsResource.generateTTS(
            {
                async onResult(json: any) {
                    try {
                        const result = await convertBase64ToAudioBlob(
                            json.data,
                            mimeType,
                        );
                        setFile(result.file);
                        setAudioResult({
                            url: result.url,
                            duration: result.duration,
                            name: result.name,
                        });
                    } catch (error) {
                        console.error('Error converting audio:', error);
                    } finally {
                        setLoading(false);
                    }
                },

                onError: (error: any) => {
                    console.error('Error generating TTS:', error);
                    setLoading(false);
                },
            },
            text,
            languageCode,
            voice,
        );
    };

    return {
        loading,
        audioResult,
        showConfirm,
        setShowConfirm,
        checkConfirm,
        generateTTS,
    };
};
